import React from "react"
import useScrollPercentage from "../hooks/useScrollPercentage"

const ScrollTracker = () => {
  const { percentage } = useScrollPercentage()

  const trackerStyle = {
    width: "4px",
    zIndex: 211,
    position: "fixed",
    top: "0px",
    right: "0px",
    height: "100%",
    transform: `scaleY(${percentage / 100})`,
    transformOrigin: "top",
    transition: "all .3s ease-out"
  } as const

  return <div id="scrollTracker" style={trackerStyle}></div>
}

export default ScrollTracker
